const WhatsAppButton = () => {
  return (
    <a
  href="https://wa.me/919873030848?text=Hello%20Akir%20Advisory%2C%20I%20need%20assistance."
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "#25D366",
    width: "55px",
    height: "55px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "0px 0px 8px rgba(0,0,0,.3)",
    zIndex: "99999"
  }}
>
  <img 
    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
    alt="WhatsApp" 
    style={{ width: "30px", height: "30px" }} 
  />
</a>

  );
};

export default WhatsAppButton;
